import React from "react";
import { styled } from "@mui/material/styles";
import Header from "./Header";
import { Box, Typography, Card, CardContent, Grid, CardHeader, TextField, Button } from "@mui/material";
import NavbarFooter from "./Components/NavbarFooter";
import { AccountCircle } from "@mui/icons-material";
import { HiUserGroup } from "react-icons/hi2";
import { useState, useEffect } from "react";
// import '../../App.css'
import { Link } from "react-router-dom";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { Toast } from "@egovernments/digit-ui-react-components";
import { useTranslation } from "react-i18next";

const InputText = styled(TextField)({
  "& label, & label.Mui-focused, & .MuiInput-root": {
    color: "#fff",
  },
  "& .Mui-focused::after": {
    borderBottomColor: "#0e7693",
  },
});

function OnlineUserServices() {
  const getUserType = () => Digit.UserService.getType();
  const history = useHistory();
  const { t } = useTranslation();
  const stateCode = Digit.ULBService.getStateId();
  const [state, setState] = useState({
    raised1: false,
    shadow1: 1,
    raised2: false,
    shadow2: 1,
    raised3: false,
    shadow3: 1,
  });
  const stateId = Digit.ULBService.getStateId();
  const [mobileNumber, setMobileNumber] = useState(null);
  const [mobileNumber1, setMobileNumber1] = useState(null);
  const [showOtpField, setOtpField] = useState(false);
  const [name, setName] = useState("");
  const [showOtpField1, setOtpField1] = useState(false);
  const [otp, setOtp] = useState(null);
  const [otp1, setOtp1] = useState(null);
  const [showToast, setShowToast] = useState(null);

  const closeToast = () => {
    setShowToast(null);
  };

  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  const handleClick = async () => {
    if (mobileNumber?.length !== 10) {
      setShowToast({ error: true, message: `Please enter a valid mobile no` });
      return;
    }
    const requestData = {
      otp: {
        mobileNumber: mobileNumber,
        userType: "citizen",
        type: "login",
        tenantId: stateCode,
      },
    };
    try {
      const res = await Digit.UserService.sendOtp(requestData, stateId);
      if (res?.isSuccessful) {
        setOtpField(true);
      }
    } catch (err) {
      setShowToast({ error: true, message: `Please register your mobile no in the portal` });
    }
  };
  const handleClick1 = async () => {
    if (mobileNumber1?.length !== 10) {
      setShowToast({ error: true, message: `Please enter a valid mobile no` });
      return;
    }
    const requestData = {
      otp: {
        mobileNumber: mobileNumber1,
        name: name,
        userType: "citizen",
        type: "register",
        tenantId: stateCode,
      },
    };
    try {
      const res = await Digit.UserService.sendOtp(requestData, stateId);
      if (res?.isSuccessful) {
        setOtpField1(true);
      }
    } catch (err) {
      setShowToast({ error: true, message: `Something went wrong, please try again!` });
    }
  };

  const handleLogin = async () => {
    const requestData = {
      username: mobileNumber,
      password: otp,
      tenantId: stateCode,
      userType: getUserType(),
    };
    try {
      const { ResponseInfo, UserRequest: info, ...tokens } = await Digit.UserService.authenticate(requestData);
      Digit.SessionStorage.set("citizen.userRequestObject", { info, ...tokens });
      Digit.UserService.setUser({ info, ...tokens });
      history.push("profile");
    } catch (error) {
      setShowToast({ error: true, message: `Something went wrong, please try again!` });
    }
  };
  const handleLogin1 = async () => {
    const requestData = {
      name,
      username: mobileNumber1,
      otpReference: otp1,
      tenantId: stateCode,
      mobileNumber: mobileNumber1,
    };
    try {
      const { ResponseInfo, UserRequest: info, ...tokens } = await Digit.UserService.registerUser(requestData, stateCode);
      Digit.SessionStorage.set("citizen.userRequestObject", { info, ...tokens });
      Digit.UserService.setUser({ info, ...tokens });
      history.push("profile");
    } catch (error) {
      setShowToast({ error: true, message: `Something went wrong, please try again!` });
    }
  };

  return (
    <div>
      <Header />
      <Box
        sx={{
          width: "80%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignContent: "center",
          margin: "3rem 2rem 1rem 10rem",
        }}
      >
        <Card
          style={{ width: "400px", height: "370px", margin: "10px", backgroundColor: "rgb(68 155 180)" }}
          //   classes={{root: state.raised ? classes.cardHovered : ""}}
          // className={ state.raised ? 'cardHovered':''}
          className="cardHovered"
          onMouseOver={() => setState({ raised1: true, shadow1: 6 })}
          onMouseOut={() => setState({ raised1: false, shadow1: 1 })}
          raised={state.raised1}
          zdepth={state.shadow1}
        >
          <CardHeader
            title="Private Professional"
            titleTypographyProps={{ variant: "h6" }}
            style={{ color: "white", alignItems: "center", marginLeft: "40px" }}
            avatar={
              // <Avatar aria-label="Private Professional" style={{marginRight:"-10px"}} variant='string'>
              <AdminPanelSettingsIcon style={{ height: "35px", width: "35px", color: "white" }} />
              //   </Avatar>
            }
          />
          <CardContent style={{ alignItems: "center", marginTop: "-17px" }}>
            <Box
              sx={{ display: "block", border: "1px solid white", borderRadius: "25px", height: "220px", width: "300px", margin: "0px 20px 0px 30px" }}
            >
              <Box sx={{ display: "flex", alignItems: "flex-end", margin: "10px 10px 10px 30px" }}>
                <AccountCircle sx={{ color: "white", mr: 1, my: 0.5 }} />
                <InputText
                  label="Mobile Number"
                  variant="standard"
                  value={mobileNumber}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (/^\d{0,10}$/.test(inputValue)) {
                      setMobileNumber(inputValue);
                    }
                  }}
                  autoComplete="off"
                />
              </Box>
              {/* <Box sx={{ display: 'flex', alignItems: 'flex-end', margin:"10px 10px 10px 30px" }}>
        <PasswordSharp sx={{ color: 'white', mr: 1, my: 0.5 }} />
        <TextField id="input-with-sx" label="Password" variant="standard" />
        </Box> */}
              <Box sx={{ display: "flex", alignItems: "normal", flexDirection: "column", margin: "10px 5px 10px 30px" }}>
                {!showOtpField && (
                  <Button
                    variant="contained"
                    size="small"
                    style={{ width: "100px", margin: "30px 10px 10px 60px", backgroundColor: "#0E7693" }}
                    onClick={handleClick}
                  >
                    Send OTP
                  </Button>
                )}
                {showOtpField && (
                  <InputText
                    label="Enter OTP"
                    style={{ height: "8px", width: "90px", color: "white", marginLeft: "70px" }}
                    variant="standard"
                    value={otp}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      if (/^\d{0,6}$/.test(inputValue)) {
                        setOtp(inputValue);
                      }
                    }}
                    autoComplete="off"
                  />
                )}
              </Box>
            </Box>
            <Button
              size="medium"
              style={{ width: "150px", border: "1px solid blue", backgroundColor: "orange", color: "white", margin: "10px 0px 0px 100px" }}
              onClick={handleLogin}
            >
              Login
            </Button>
          </CardContent>
        </Card>
        <Card
          style={{
            width: "400px",
            height: "400px",
            margin: "10px",
            alignItems: "center",
            overflow: "auto",
            maxHeight: "380px",
            scrollbarWidth: "5px",
          }}
          className="cardHovered1"
          onMouseOver={() => setState({ raised2: true, shadow2: 3 })}
          onMouseOut={() => setState({ raised2: false, shadow2: 1 })}
          raised={state.raised2}
          zdepth={state.shadow2}
        >
          <CardHeader
            title="New User"
            titleTypographyProps={{ variant: "h6" }}
            style={{ color: "#144398", alignItems: "center", marginLeft: "80px" }}
            avatar={
              // <Avatar aria-label="Private Professional" style={{marginRight:"-10px"}}>
              <PersonAddIcon style={{ height: "35px", width: "35px", color: "#144398" }} />
              //   </Avatar>
            }
          />
          <CardContent style={{ alignItems: "center", marginTop: "-17px" }}>
            <Grid
              container
              spacing={1}
              style={{ display: "flex", flexDirection: "column", margin: "0px 10px 10px 0px" }}
              justifyContent="space-between"
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Typography variant="body2">
                Form of application for permission of Development of Land / Construction of Building. <strong>(Form - 12)</strong>
              </Typography>
              <Link style={{ textDecoration: "none", color: "orange", textAlign: "center" }} to="/digit-ui/citizen/obps/edcrscrutiny/apply">
                Apply Now
              </Link>
              <Typography variant="body2">
                Apply For Form12 Self Certification<strong>(Form - 12 Self Certification)</strong>
              </Typography>
              <Link style={{ textDecoration: "none", color: "orange", textAlign: "center" }} to="/digit-ui/citizen/obps/edcrscrutiny/apply">
                Apply Now
              </Link>
              <Typography variant="body2">
                Form of application for permission of sub-division / development of land. <strong>(Form - 11)</strong>
              </Typography>
              <Link style={{ textDecoration: "none", color: "orange", textAlign: "center" }} to="/digit-ui/citizen/obps/services/form11">
                Apply Now
              </Link>
              <Typography variant="body2">
                Form Application for composition of offences under section 39-C read with sub-section (3) of section <strong>(Form - 26)</strong>
              </Typography>
              <Link style={{ textDecoration: "none", color: "orange", textAlign: "center" }} to="/digit-ui/citizen/obps/services/form26">
                Apply Now
              </Link>
              <Typography variant="body2">Registered citizen user may apply for NOC of water, Electricity and severage.</Typography>
              <Link style={{ textDecoration: "none", color: "orange", textAlign: "center" }} to="/digit-ui/citizen/InProgreeService">
                Apply Now
              </Link>
              <Typography variant="body2">Registered citizen user may apply for Mobile Tower Application(Application For MObile Tower).</Typography>
              <Link style={{ textDecoration: "none", color: "orange", textAlign: "center" }} to="/digit-ui/citizen/InProgreeService">
                Apply Now
              </Link>
              <Typography variant="body2">Registered citizen user may apply for Change of Land Use(Change of Land use).</Typography>
              <Link style={{ textDecoration: "none", color: "orange", textAlign: "center" }} to="/digit-ui/citizen/InProgreeService">
                Apply Now
              </Link>
              <Typography variant="body2">Form16(Application Of Appeal)</Typography>
              <Link style={{ textDecoration: "none", color: "orange", textAlign: "center" }} to="/digit-ui/citizen/InProgreeService">
                Apply Now
              </Link>
              <Typography variant="body2">Form34(Real Estate Projects)</Typography>
              <Link style={{ textDecoration: "none", color: "orange", textAlign: "center" }} to="/digit-ui/citizen/InProgreeService">
                Apply Now
              </Link>
            </Grid>
          </CardContent>
        </Card>
        <Card
          style={{ width: "400px", height: "370px", margin: "10px", backgroundColor: "rgb(68 155 180)" }}
          className="cardHovered2"
          onMouseOver={() => setState({ raised3: true, shadow3: 3 })}
          onMouseOut={() => setState({ raised3: false, shadow3: 1 })}
          raised={state.raised3}
          zdepth={state.shadow3}
        >
          <CardHeader
            title="Citizen & Others"
            titleTypographyProps={{ variant: "h6" }}
            style={{ color: "white", marginLeft: "40px" }}
            avatar={
              // <Avatar>
              <HiUserGroup style={{ height: "35px", width: "35px", color: "white" }} />
              //   </Avatar>
            }
          />

          <CardContent style={{ alignItems: "center", marginTop: "-17px" }}>
            <Box
              sx={{
                display: "block",
                border: "1px solid white",
                borderRadius: "25px",
                height: "220px",
                width: "300px",
                margin: "10px 20px 10px 30px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "flex-end", margin: "10px 10px 10px 20px" }}>
                <LocalPhoneIcon sx={{ color: "white", mr: 1, my: 0.5 }} />
                <InputText
                  label="Mobile Number"
                  autoComplete="off"
                  variant="standard"
                  value={mobileNumber1}
                  sx={{ color: "white" }}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (/^\d{0,10}$/.test(inputValue)) {
                      setMobileNumber1(inputValue);
                    }
                  }}
                />
              </Box>
              <Box sx={{ display: "flex", alignItems: "flex-end", margin: "10px 10px 10px 20px" }}>
                <AccountCircle sx={{ color: "white", mr: 1, my: 0.5 }} />
                <InputText
                  label="Name"
                  autoComplete="off"
                  variant="standard"
                  value={name}
                  sx={{ color: "white" }}
                  onChange={(e) => setName(e.target.value)}
                />
              </Box>
              <Box sx={{ display: "flex", alignItems: "normal", flexDirection: "column", margin: "10px 5px 10px 30px" }}>
                {!showOtpField1 && (
                  <Button
                    variant="contained"
                    size="small"
                    style={{ backgroundColor: "#0E7693", width: "100px", margin: "30px 10px 10px 60px" }}
                    onClick={handleClick1}
                  >
                    Send OTP
                  </Button>
                )}
                {showOtpField1 && (
                  <InputText
                    label="Enter OTP"
                    style={{ height: "8px", width: "90px", color: "white", marginLeft: "70px" }}
                    variant="standard"
                    value={otp1}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      if (/^\d{0,6}$/.test(inputValue)) {
                        setOtp1(inputValue);
                      }
                    }}
                    autoComplete="off"
                  />
                )}
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <p
                  style={{ color: "#FFA600", fontSize: "12px", cursor: "pointer", textAlign: "center", fontWeight: "500", marginTop: "-7px" }}
                  onClick={() => history.push("login")}
                >
                  Already Registered? Login here...
                </p>
              </Box>
            </Box>
            <Button
              size="medium"
              style={{ width: "150px", border: "1px solid blue", backgroundColor: "orange", color: "white", margin: "10px 0px 0px 100px" }}
              onClick={handleLogin1}
            >
              Register
            </Button>
          </CardContent>
        </Card>
      </Box>
      <NavbarFooter />
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </div>
  );
}

export default OnlineUserServices;
